import {
    TotalResponsesBox,
    AnswerRateBox,
    CreatedByBox,
    SentOutBox,
    StatusBadgeBox,
} from "./StatusBoxes";
import ActionButtons from "./ActionButtons/ActionButtons";
import { useCurrentSurvey } from "@pulse/hooks/surveyHooks";
import ResponseList from "./ResponseList";
import { Link } from "@tanstack/react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import usePulseId from "@pulse/hooks/usePulseId";
import { Separator, PageHeaderRight, PageHeaderBack } from "frontend-components";
import SurveyDescriptionBanner from "./SurveyDescriptionBanner";

export default function ResponseOverviewArea({ surveyId }: { surveyId: number }) {
    const { t } = useTranslation();
    const pulseId = usePulseId();
    const { data: survey } = useCurrentSurvey();

    if (!survey) return null;

    return (
        <>
            <PageHeaderBack>
                <Link
                    to="/$customerId/pulse/$pulseId"
                    from="/$customerId"
                    params={{ pulseId: String(pulseId) }}
                    className="group text-text-secondary inline-flex items-center gap-2 self-start text-sm hover:underline"
                >
                    <FontAwesomeIcon
                        icon={faArrowLeft}
                        className="text-compendia-greige group-hover:text-compendia-foreground size-4 transition-all duration-300 ease-out group-hover:-translate-x-1"
                    />
                    {t("survey.backToOverview")}
                </Link>
            </PageHeaderBack>
            <PageHeaderRight>
                <ActionButtons />
            </PageHeaderRight>
            <Separator className="bg-compendia-greige" />
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                <TotalResponsesBox surveyId={surveyId} />
                <AnswerRateBox surveyId={surveyId} />
                <CreatedByBox createdBy={survey.createdBy} />
                <SentOutBox surveyId={surveyId} />
                <StatusBadgeBox surveyId={surveyId} />
            </div>

            <SurveyDescriptionBanner description={survey.description} />

            <div>
                <ResponseList />
            </div>
        </>
    );
}
